const twoPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const threePlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "French", label: "French" },
  { value: "", label: "x" },
];
const fourPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "French", label: "French" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const sixPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "Core", label: "Core" },
  { value: "Immersion", label: "Immersion" },
  { value: "Extended", label: "Extended" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const frenchPlans = [
  { value: "Core", label: "Core" },
  { value: "Immersion", label: "Immersion" },
  { value: "Extended", label: "Extended" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const ersCompleted = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "NA", label: "NA" },
  { value: "", label: "x" },
];
const ersBenchmark = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "NA", label: "NA" },
  { value: "", label: "x" },
];
const selectItems = [
  { value: "E", label: "E" },
  { value: "G", label: "G" },
  { value: "S", label: "S" },
  { value: "N", label: "N" },
  { value: "", label: "x" },
];

export { twoPlans, threePlans, fourPlans, sixPlans, frenchPlans, ersCompleted, ersBenchmark , selectItems };
